var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_878_6220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_878_6220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 20C2.87533 20 2.48296 19.8368 2.15658 19.5104C1.83019 19.184 1.66699 18.7916 1.66699 18.3333C1.66699 17.875 1.83019 17.4826 2.15658 17.1562C2.48296 16.8298 2.87533 16.6666 3.33366 16.6666H16.667C17.1253 16.6666 17.5177 16.8298 17.8441 17.1562C18.1705 17.4826 18.3337 17.875 18.3337 18.3333C18.3337 18.7916 18.1705 19.184 17.8441 19.5104C17.5177 19.8368 17.1253 20 16.667 20H3.33366ZM5.00033 13.3333H6.16699L12.667 6.85413L11.4795 5.66663L5.00033 12.1666V13.3333ZM3.33366 14.1666V11.8125C3.33366 11.7013 3.35449 11.5937 3.39616 11.4895C3.43783 11.3854 3.50033 11.2916 3.58366 11.2083L12.667 2.14579C12.8198 1.99301 12.9969 1.87496 13.1982 1.79163C13.3996 1.70829 13.6114 1.66663 13.8337 1.66663C14.0559 1.66663 14.2712 1.70829 14.4795 1.79163C14.6878 1.87496 14.8753 1.99996 15.042 2.16663L16.1878 3.33329C16.3545 3.48607 16.476 3.66663 16.5524 3.87496C16.6288 4.08329 16.667 4.29857 16.667 4.52079C16.667 4.72913 16.6288 4.93399 16.5524 5.13538C16.476 5.33677 16.3545 5.52079 16.1878 5.68746L7.12533 14.75C7.04199 14.8333 6.94824 14.8958 6.84408 14.9375C6.73991 14.9791 6.63227 15 6.52116 15H4.16699C3.93088 15 3.73296 14.9201 3.57324 14.7604C3.41352 14.6007 3.33366 14.4027 3.33366 14.1666Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4a1f5f5f80dedf81842c656ad3bd3229.svg";
export { ForwardRef as ReactComponent };